import * as CONST from "./actionTypes";

export const deleteFacbook = (payload, callBack) => {
  return {
    type: CONST.DELETE_FACEBOOK,
    payload: payload,
    callBack,
  };
};

export const deleteFacbook_Success = (payload) => ({
  type: CONST.DELETE_FACEBOOK_SUCCESS,
  payload,
});

export const deleteFacbook_Fail = (payload) => ({
  type: CONST.DELETE_FACEBOOK_FAIL,
  payload,
});

export const deleteAllFacbook = (payload, callBack) => {
  return {
    type: CONST.DELETEALL_FACEBOOK,
    payload: payload,
    callBack,
  };
};

export const deleteAllFacbook_Success = (payload) => ({
  type: CONST.DELETEALL_FACEBOOK_SUCCESS,
  payload,
});

export const deleteAllFacbook_Fail = (payload) => ({
  type: CONST.DELETEALL_FACEBOOK_FAIL,
  payload,
});

export const deleteInstagram = (payload, callBack) => {
  return {
    type: CONST.DELETE_INSTAGRAM,
    payload: payload,
    callBack,
  };
};

export const deleteInstagram_Success = (payload) => ({
  type: CONST.DELETE_INSTAGRAM_SUCCESS,
  payload,
});

export const deleteInstagram_Fail = (payload) => ({
  type: CONST.DELETE_INSTAGRAM_FAIL,
  payload,
});

export const deleteAllInstagram = (payload, callBack) => {
  return {
    type: CONST.DELETEALL_INSTAGRAM,
    payload: payload,
    callBack,
  };
};

export const deleteAllInstagram_Success = (payload) => ({
  type: CONST.DELETEALL_INSTAGRAM_SUCCESS,
  payload,
});

export const deleteAllInstagram_Fail = (payload) => ({
  type: CONST.DELETEALL_INSTAGRAM_FAIL,
  payload,
});

export const deleteTwitter = (payload, callBack) => {
  return {
    type: CONST.DELETE_TWITTER,
    payload: payload,
    callBack,
  };
};

export const deleteTwitter_Success = (payload) => ({
  type: CONST.DELETE_TWITTER_SUCCESS,
  payload,
});

export const deleteTwitter_Fail = (payload) => ({
  type: CONST.DELETE_TWITTER_FAIL,
  payload,
});

export const deleteAllTwitter = (payload, callBack) => {
  return {
    type: CONST.DELETEALL_TWITTER,
    payload: payload,
    callBack,
  };
};

export const deleteAllTwitter_Success = (payload) => ({
  type: CONST.DELETEALL_TWITTER_SUCCESS,
  payload,
});

export const deleteAllTwitter_Fail = (payload) => ({
  type: CONST.DELETEALL_TWITTER_FAIL,
  payload,
});

export const deleteYoutube = (payload, callBack) => {
  return {
    type: CONST.DELETE_YOUTUBE,
    payload: payload,
    callBack,
  };
};

export const deleteYoutube_Success = (payload) => ({
  type: CONST.DELETE_YOUTUBE_SUCCESS,
  payload,
});

export const deleteYoutube_Fail = (payload) => ({
  type: CONST.DELETE_YOUTUBE_FAIL,
  payload,
});

export const deleteAllYoutube = (payload, callBack) => {
  return {
    type: CONST.DELETEALL_YOUTUBE,
    payload: payload,
    callBack,
  };
};

export const deleteAllYoutube_Success = (payload) => ({
  type: CONST.DELETEALL_YOUTUBE_SUCCESS,
  payload,
});

export const deleteAllYoutube_Fail = (payload) => ({
  type: CONST.DELETEALL_YOUTUBE_FAIL,
  payload,
});

export const deleteTiktok = (payload, callBack) => {
  return {
    type: CONST.DELETE_TIKTOK,
    payload: payload,
    callBack,
  };
};

export const deleteTiktok_Success = (payload) => ({
  type: CONST.DELETE_TIKTOK_SUCCESS,
  payload,
});

export const deleteTiktok_Fail = (payload) => ({
  type: CONST.DELETE_TIKTOK_FAIL,
  payload,
});

export const deleteAllTiktok = (payload, callBack) => {
  return {
    type: CONST.DELETEALL_TIKTOK,
    payload: payload,
    callBack,
  };
};

export const deleteAllTiktok_Success = (payload) => ({
  type: CONST.DELETEALL_TIKTOK_SUCCESS,
  payload,
});

export const deleteAllTiktok_Fail = (payload) => ({
  type: CONST.DELETEALL_TIKTOK_FAIL,
  payload,
});

export const deleteContact = (payload, callBack) => {
  return {
    type: CONST.DELETE_CONTACT,
    payload: payload,
    callBack,
  };
};

export const deleteContact_Success = (payload) => ({
  type: CONST.DELETE_CONTACT_SUCCESS,
  payload,
});

export const deleteContact_Fail = (payload) => ({
  type: CONST.DELETE_CONTACT_FAIL,
  payload,
});

export const deleteAllContact = (payload, callBack) => {
  return {
    type: CONST.DELETEALL_CONTACT,
    payload: payload,
    callBack,
  };
};

export const deleteAllContact_Success = (payload) => ({
  type: CONST.DELETEALL_CONTACT_SUCCESS,
  payload,
});

export const deleteAllContact_Fail = (payload) => ({
  type: CONST.DELETEALL_CONTACT_FAIL,
  payload,
});

export const deleteSubscriber = (payload, callBack) => {
  return {
    type: CONST.DELETE_SUBSCRIBER,
    payload: payload,
    callBack,
  };
};

export const deleteSubscriber_Success = (payload) => ({
  type: CONST.DELETE_SUBSCRIBER_SUCCESS,
  payload,
});

export const deleteSubscriber_Fail = (payload) => ({
  type: CONST.DELETE_SUBSCRIBER_FAIL,
  payload,
});

export const deleteAllSubscriber = (payload, callBack) => {
  return {
    type: CONST.DELETEALL_SUBSCRIBER,
    payload: payload,
    callBack,
  };
};

export const deleteAllSubscriber_Success = (payload) => ({
  type: CONST.DELETEALL_SUBSCRIBER_SUCCESS,
  payload,
});

export const deleteAllSubscriber_Fail = (payload) => ({
  type: CONST.DELETEALL_SUBSCRIBER_FAIL,
  payload,
});
